module.exports = __webpack_public_path__ + "img/white_linkedin.7c588245.svg";